import { IAuthContextState, IDecodedJWTToken } from "./AuthProvider.types";

export const AUTH_STORAGE_KEY = "auth_info";

export const saveUserStateInLocalStorage = (authInfo: IAuthContextState) =>
  localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authInfo));

export const getUserStateFromLocalStorage = (): IAuthContextState | null => {
  const authInfo = localStorage.getItem(AUTH_STORAGE_KEY);
  return authInfo ? JSON.parse(authInfo) : null;
};

export const removeUserStateFromLocalStorage = () =>
  localStorage.removeItem(AUTH_STORAGE_KEY);

function base64DecodeUnicode(str: string): string {
  return decodeURIComponent(
    atob(str)
      .split("")
      .map((c) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`)
      .join(""),
  );
}
export function decodeJWTToken(token: string): IDecodedJWTToken | null {
  try {
    if (!token) return null;

    const parts = token.split(".");
    if (parts.length !== 3) throw new Error("Invalid token structure");

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const payload = base64DecodeUnicode(base64);

    return JSON.parse(payload);
  } catch (error) {
    console.error("Error decoding token:", error);
    throw error;
  }
}



export const removeExternalFromStorage = () => {
 const authInfo = localStorage.getItem(AUTH_STORAGE_KEY);
 if(authInfo) {
    const parseAuthInfo = JSON.parse(authInfo);
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify({ ...parseAuthInfo, external_auth: null }));
 }
}
  